import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state() {
    return {
      salonsOverview: [],
      salonDailyReports: [],
      salonDetailedReport: {},
      salariesReport: undefined,
      discountSummary: {
        discountCount: 0,
        totalDiscountAmount: 0
      },
      todayPaymentsReport: {}
    };
  },
  actions,
  getters,
  mutations
};
